import { useSelector } from "react-redux";
import MainPageLayout from "../../../layout/MainPageLayout";
import HistoryHeaderTabs from "../components/history/HistoryHeaderTabs";
import CylinderHistoryContent from "../components/history/cylinder-history/CylinderHistoryContent";
import VehicleHistoryContent from "../components/history/vehicle-history/VehicleHistoryContent";
import useGetMultiple from "../../../CustomHooks/useAxios/useGetMultiple";
import LoadingDisplay from "../../../components/UI/LoadingDisplay";
import DialogBox from "../../../components/UI/DialogBox";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import { CYLINDER_SETUP, VEHICLE_SETUP } from "../../../api/allApi_List";

const CylinderHistoryPage = () => {
  const { data, isLoaded, error } = useGetMultiple([
    CYLINDER_SETUP,
    VEHICLE_SETUP,
  ]);
  const activeHeaderTab = useSelector(
    (state) => state.activeHeaderTab.activeHeaderTab,
  );
  const headerTabs = <HistoryHeaderTabs />;

  return (
    <MainPageLayout headerTabs={headerTabs}>
      <div className="form-container">
        {isLoaded && !error ? (
          <>
            {activeHeaderTab === "cylinderHistory" && (
              <CylinderHistoryContent setupData={data[0]} />
            )}
            {activeHeaderTab === "vehicleHistory" && (
              <VehicleHistoryContent setupData={data[1]} />
            )}
          </>
        ) : error ? (
          <DialogBox
            title="Error"
            message={handleErrMessage(error)}
            isErrorHandleButtons={true}
          />
        ) : (
          <LoadingDisplay />
        )}
      </div>
    </MainPageLayout>
  );
};

export default CylinderHistoryPage;
